export const VERIFY_OTP = "VERIFY_OTP"
export const VERIFY_OTP_SUCCESSFUL = "VERIFY_OTP_SUCCESSFUL"
export const VERIFY_OTP_FAILED = "VERIFY_OTP_FAILED"
export const VERIFY_OTP_RESET = "VERIFY_OTP_RESET"